import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaPhone, FaEnvelope, FaGlobe, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
          <path d="M0,30 C300,60 900,0 1200,30 L1200,60 L0,60 Z" fill="#1a3a5c" />
        </svg>
      </div>

      <div className="footer-content">
        <div className="footer-grid">
          {/* Columna 1 — Marca */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon"><FaHome /></div>
              <div>
                <div className="footer-logo-name">Casa Bonita</div>
                <div className="footer-logo-sub">Agente de Bienes Raíces</div>
              </div>
            </div>
            <p className="footer-slogan">"Tu hogar ideal comienza aquí"</p>
            <div className="footer-social">
              <a href="https://wa.me/16474700762?text=Hola!%20Me%20interesa%20saber%20m%C3%A1s%20sobre%20sus%20propiedades." target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>

            </div>
          </div>

          {/* Columna 2 — Navegación */}
          <div className="footer-nav">
            <h4>Navegación</h4>
            <ul>
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/propiedades">Propiedades</Link></li>
              <li><Link to="/propiedades?type=CASA">Casas</Link></li>
              <li><Link to="/propiedades?type=APARTAMENTO">Apartamentos</Link></li>
              <li><Link to="/propiedades?type=TERRENO">Terrenos</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
            </ul>
          </div>

          {/* Columna 3 — Agentes */}
          <div className="footer-agents">
            <h4>Nuestros Agentes</h4>
            <div className="agent-card">
              <div className="agent-avatar">L</div>
              <div>
                <strong>Lilian</strong>
                <a href="mailto:linareslilian27@gmail.com">linareslilian27@gmail.com</a>
              </div>
            </div>
            <div className="agent-card">
              <div className="agent-avatar">C</div>
              <div>
                <strong>Carol</strong>
                <a href="mailto:clinares79@gmail.com">clinares79@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Columna 4 — Contacto */}
          <div className="footer-contact">
            <h4>Contáctanos</h4>
            <ul className="contact-list">
              <li>
                <FaPhone className="contact-icon" />
                <div>
                  <a href="tel:+16474700762">+1 (647) 4700762</a>
                  <a href="tel:+50379416355">+503 7941-6355</a>
                  <a href="tel:+50377960598">+503 7796-0598</a>
                </div>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <div>
                  <a href="mailto:linareslilian27@gmail.com">linareslilian27@gmail.com</a>
                  <a href="mailto:clinares79@gmail.com">clinares79@gmail.com</a>
                </div>
              </li>
              <li>
                <FaGlobe className="contact-icon" />
                <a href="https://www.casabonitasv.com" target="_blank" rel="noopener noreferrer">
                  www.casabonitasv.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Casa Bonita — Agente de Bienes Raíces. Todos los derechos reservados.</p>
          <p>El Salvador</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
